import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Production } from '../../référentiel-métier-processus/processus-aptitude/models/production.model';
import { ProductionCreateRequest } from '../requests/production-create-request.model';
import { ProductionUpdateRequest } from '../requests/production-update-request.model';
import { RessourcesOrdonneesRequest } from '../requests/ressources-ordonnées-request.model';

@Injectable({
  providedIn: 'root',
})
export class ProductionService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/productions`;

  create(data: ProductionCreateRequest) {
    return this.#http.post<Production[]>(this.BASE_URL, data);
  }

  update(idCartographie: string, idProduction: string, data: ProductionUpdateRequest) {
    return this.#http.put<void>(this.BASE_URL + `/${idProduction}`, data, { params: { idCartographie } });
  }

  ordonnerRessources(idProduction: string, data: RessourcesOrdonneesRequest) {
    return this.#http.put<void>(this.BASE_URL + `/${idProduction}/ressources/ordre`, data);
  }

  supprimer(idProduction: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idProduction);
  }

  get(idProduction: string) {
    return this.#http.get<Production>(this.BASE_URL + '/' + idProduction);
  }
}
